import type { CatalogComponent } from '@/types/components'

const BASE = import.meta.env.VITE_EDGE_API_URL ?? ''

/**
 * Fetch available components for the authenticated tenant user.
 * Returns all active components; locked components have locked: true.
 */
export async function fetchAvailableComponents(token: string): Promise<CatalogComponent[]> {
  const res = await fetch(`${BASE}/components`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })

  if (!res.ok) {
    throw new Error('Gagal memuat katalog komponen')
  }

  return res.json() as Promise<CatalogComponent[]>
}
